import { createFileRoute, notFound } from "@tanstack/react-router";
import { HijriDatePage } from "@/components/pages/HijriDatePage";
import { HIJRI_MONTHS_EN, daysInHijriMonth, hijriToGregorian } from "@/lib/calendar/hijri";

const MONTHS_EN = [
  "January","February","March","April","May","June",
  "July","August","September","October","November","December",
];

export const Route = createFileRoute("/en/hijri-calendar/$hyear/$hmonth/$hday")({
  beforeLoad: ({ params }) => {
    if (
      params.hyear.startsWith("$") ||
      params.hmonth.startsWith("$") ||
      params.hday.startsWith("$")
    ) {
      throw notFound();
    }
  },
  loader: ({ params }) => {
    const hYear = parseInt(params.hyear, 10);
    const hMonth = parseInt(params.hmonth, 10);
    const hDay = parseInt(params.hday, 10);
    if (!Number.isFinite(hYear) || hYear < 1300 || hYear > 1600) throw notFound();
    if (!Number.isFinite(hMonth) || hMonth < 1 || hMonth > 12) throw notFound();
    if (!Number.isFinite(hDay) || hDay < 1 || hDay > daysInHijriMonth(hYear, hMonth)) throw notFound();
    return { hYear, hMonth, hDay };
  },
  head: ({ loaderData }) => {
    if (!loaderData) return {};
    const { hYear, hMonth, hDay } = loaderData;
    const monthName = HIJRI_MONTHS_EN[hMonth - 1];
    const g = hijriToGregorian(hYear, hMonth, hDay);
    const title = `${hDay} ${monthName} ${hYear} AH - ${g.d} ${MONTHS_EN[g.m - 1]} ${g.y}`;
    const desc = `Hijri date detail ${hDay} ${monthName} ${hYear} AH corresponds to ${g.d} ${MONTHS_EN[g.m - 1]} ${g.y}, with weton, Islamic events, and Indonesian holidays.`;
    const enUrl = `https://hari.co.id/en/hijri-calendar/${hYear}/${hMonth}/${hDay}/`;
    return {
      meta: [
        { title },
        { name: "description", content: desc },
        { property: "og:title", content: title },
        { property: "og:description", content: desc },
        { property: "og:url", content: enUrl },
        { property: "og:locale", content: "en_US" },
        { property: "og:locale:alternate", content: "id_ID" },
      ],
      links: [{ rel: "canonical", href: enUrl }],
    };
  },
  component: () => {
    const { hYear, hMonth, hDay } = Route.useLoaderData();
    return <HijriDatePage hYear={hYear} hMonth={hMonth} hDay={hDay} locale="en" />;
  },
  notFoundComponent: () => <div className="p-8 text-center">Invalid Hijri date.</div>,
  errorComponent: ({ error }) => <div className="p-8 text-center">Error: {error.message}</div>,
});